var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"block-head__img",attrs:{"src":"/dist/assets/front_white/img/landing_about/img-bimlib-team.svg","alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }